import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { IonPage, useIonViewDidEnter } from '@ionic/react';
import { useIsKeyBoardShown } from 'src/hooks/useIsKeyboardShown';
import {
  Container_v2 as Container,
  AppHeader_v2 as AppHeader,
  Button_v2 as Button,
  AppFooter_v2 as AppFooter,
  ScreenInput,
  Typography,
  TypographyVariantsEnum,
  IconArrowLeft,
} from '@mindly/ui-components';
import useToast from 'src/context/ToastContext/ToastContext';
import { useUpdateProfile } from 'src/shared/hooks/useUpdateProfile';
import { useAuthFlow } from 'src/shared';

const ProfilePassword: React.FC = () => {
  const { t } = useTranslation('profile');
  const history = useHistory();
  const { updatePassword } = useAuthFlow();
  const { showToast } = useToast();
  const { successfullyUpdatedProfile } = useUpdateProfile();
  const isKeyboardShown = useIsKeyBoardShown();

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  useIonViewDidEnter(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  const onSubmitAction = async () => {
    try {
      if (inputValue) {
        setIsLoading(true);
        await updatePassword(inputValue);

        setIsLoading(false);
        setInputValue('');
        successfullyUpdatedProfile(true, true);
      }
    } catch (error) {
      showToast({ error });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <IonPage>
      <AppHeader className="flex flex-row items-start mb-4 cursor-pointer">
        <IconArrowLeft onClick={() => history.back()} />
      </AppHeader>
      <Container isFlexContainer>
        <div className={'flex flex-col gap-1'}>
          <Typography variant={TypographyVariantsEnum.Title28Semi}>
            {t('personal_details.edit_password.title')}
          </Typography>
        </div>
        <ScreenInput
          ref={inputRef}
          type={'password'}
          name={'client-name'}
          placeholder={t('personal_details.edit_password.title')}
          value={inputValue}
          onChange={(e: any) => setInputValue(e.target.value)}
          required
        />
      </Container>
      <AppFooter transparent bottomSaveArea={!isKeyboardShown}>
        <Button
          isLoading={isLoading}
          disabled={!inputValue || isLoading}
          fullWidth
          size={'large'}
          onClick={() => onSubmitAction()}
        >
          {t('save_button')}
        </Button>
      </AppFooter>
    </IonPage>
  );
};

export default ProfilePassword;
